export const NOTES_SEARCH_LOADING = 'NOTES_SEARCH_LOADING'
export const SET_NOTES_SEARCH_DATA = 'SET_NOTES_SEARCH_DATA'
export const CLEAR_NOTES_SEARCH_DATA = 'CLEAR_NOTES_SEARCH_DATA'
